import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

export const Section = styled(Box)`
  row-gap: 24px;
  flex-direction: column;
`;
